export {
  BidUpgradeType,
  getBidUpgradeName,
  getUpgradeName,
  getUpgradeOrder,
  isUpgradeType,
  transformBidUpgradeSubType,
  transformUpgradeSubType,
  transformUpgradeType,
  UpgradeName,
  UpgradeSubType,
  UpgradeTagSize,
  UpgradeType,
} from './upgrade-tag.component';
